const continents = [
  'Asia',
  'Africa',
  'Europe',
  'Oceania',
  'North America',
  'South America'];

export default continents;
